import { createFileRoute } from "@tanstack/react-router";
import { requireAnonymous } from "@/lib/auth-guard";

export const Route = createFileRoute("/auth/phone")({
  beforeLoad: requireAnonymous,
});
